import { css } from "@emotion/react";

import Box from "../layout/Box";
import { useTheme } from "../theme";

import { shimmerStyle } from "./styles";

const Shimmer: React.FC = () => {
  const { theme } = useTheme();
  return (
    <Box
      css={css`
        ${shimmerStyle(theme)}
      `}
    />
  );
};

export default Shimmer;
